import * as React from 'react';
import styled from 'styled-components';
import { Footer } from './elements/Footer';
import { LoadingPageOverlay } from '../../LoadingPageOverlay';
import { MainNavigation } from './elements/MainNavigation/MainNavigation';
import { tablet } from '../../BreakPoints';
import { UserToken } from '../../../amorg-common'
import { EnvironmentBanner } from './elements/EnvironmentBanner';
import { PublicPageProvider } from '../../../pages/_contexts/PublicPageContext';

export type CorePageWrapperProps = React.PropsWithChildren<{
    activeUser: UserToken | null,
    loading: boolean,
    hideMenu?:boolean,
    selectedMenuItemKey?:string
}>

export const CorePageWrapper = ({ activeUser, loading, hideMenu, selectedMenuItemKey, children }: CorePageWrapperProps) => {

    return (
        <PublicPageProvider>
        {!hideMenu && activeUser !== null ? (
            <Main>
                
                <MainNavigation activeUser={activeUser} loading={loading} hideMenu={hideMenu} selectedMenuItemKey={selectedMenuItemKey} />
                
            
                <CoreContent className="mainContent">
                    <EnvironmentBanner />
                    <LoadingPageOverlay loading={loading} />
                    {children}
                </CoreContent>
                
                <Footer siteId={activeUser?.siteId} />
                
            </Main>
        ) : (
            <MainLogin>
                <CoreContent className="mainContent">
                    <LoadingPageOverlay loading={loading} />
                    {children}
                </CoreContent>
                
                <Footer />
                
            </MainLogin>
            )
        }
    </PublicPageProvider>

    )
};

const Main = styled.div`
    display:grid;
    min-height: 100%;
    grid-template-columns: 320px auto;
    grid-template-rows: auto min-content;
    grid-template-areas:
        "navigation content"
        "navigation footer";

    @media (max-width: ${tablet}px) {
        grid-template-columns: auto;
        grid-template-rows: 80px auto auto;
        grid-template-areas:
        "navigation"
        "content"
        "footer";
    }
`;

const MainLogin = styled.div`
    display:grid;
    min-height: 100%;
    grid-template-rows: auto min-content;
    grid-template-areas:
        "content"
        "footer";
`;


const CoreContent = styled.div`
    background: white;
    position: relative;
    z-index: 10;
    grid-area: content;
`;